import React from "react";

import classNames from "classnames";

import Tooltip from "../tooltip/Tooltip";

import type { JSX } from "react";

interface ErrorMessageProps {
  error?: {
    message?: string;
  };
  isTooltip?: boolean;
  name?: string;
  isCompact?: boolean;
}

function ErrorMessage({
  error,
  isTooltip,
  name,
  isCompact,
}: ErrorMessageProps): JSX.Element | null {
  const errorMessage = typeof error?.message === "string" ? error?.message : "";

  if (isTooltip) {
    return (
      <Tooltip isError isOpen id={`field-${name}-tooltip`} place="bottom" />
    );
  }

  const containerClassNames = classNames(
    "absolute block whitespace-nowrap text-destructive top-full",
    {
      "top-[60px]": isCompact,
    },
  );

  return <span className={containerClassNames}>{errorMessage}</span>;
}

export default ErrorMessage;
